import type {
  CancelRepairArgs,
  CancelRepairExecResponse,
  CancelRepairExecVariables,
  RepairType,
} from '@src/types';

import {
  exec,
  getApiToken,
} from '../utils';

const gql = String.raw;

/**
 * Cancels a repair by UUID
 * Automatically exchanges JWT for badge token if needed
 * @param args - Repair UUID
 * @returns Promise resolving to canceled repair data
 */
export const cancelRepair = async (
  args: CancelRepairArgs
): Promise<RepairType> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const variables = {
    ...args,
    token: apiToken,
  };

  const mutation = gql`
    mutation cancelRepair(
      $token: String!
      $repairUuid: String!
    ) {
      restUser(token: $token) {
        repair(uuid: $repairUuid) {
          cancelRepair {
            uuid
          }
        }
      }
    }
  `;

  const data = await exec<CancelRepairExecVariables, CancelRepairExecResponse>(
    mutation,
    {
      variables,
    }
  );

  return data.restUser.repair.cancelRepair;
};
